import React from 'react';
import { BookUser, Library, Sparkles } from 'lucide-react';
import { MenuItem, MenuItemView } from '../Sidebar';
import { getModuleKeyForPath } from '../../../config/permissionModules';
import { resolveModuleKeyForPath } from '../../../config/routes.config';
import { PARAMETER_PERMISSION_MODULE_KEYS } from '../../../modules/configuration-settings/parameterModules';

const ListIcon = (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
  </svg>
);

const CalendarIcon = (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

export const sidebarItems: MenuItem[] = [
  {
    name: 'Dashboard',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
    path: '/dashboard',
    views: [{ type: 'list', label: 'Dashboard', path: '/dashboard', icon: ListIcon }] as MenuItemView[],
  },
  {
    name: 'Favorites',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
      </svg>
    ),
    children: [],
  },
  {
    name: 'Emails',
    moduleGroupKey: 'communication',
    path: '/emails',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    name: 'Library',
    moduleGroupKey: 'communication',
    path: '/library',
    permissionModuleKey: 'emails',
    icon: <Library className="w-5 h-5" strokeWidth={1.75} aria-hidden />,
  },
  {
    name: 'Secure file link',
    moduleGroupKey: 'communication',
    path: '/file-send',
    permissionModuleKey: 'emails',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
      </svg>
    ),
  },
  {
    name: 'Address Book',
    moduleGroupKey: 'communication',
    path: '/clients',
    icon: <BookUser className="w-5 h-5" strokeWidth={1.75} aria-hidden />,
    views: [
      { type: 'list', label: 'Address Book', path: '/clients', icon: ListIcon },
    ] as MenuItemView[],
  },
  {
    name: 'AI Chat',
    path: '/ai-chat',
    permissionModuleKey: 'dashboard',
    icon: <Sparkles className="w-5 h-5" strokeWidth={1.75} aria-hidden />,
    views: [{ type: 'list', label: 'AI Chat', path: '/ai-chat', icon: ListIcon }] as MenuItemView[],
  },
  {
    name: 'Appointments',
    moduleGroupKey: 'sales_marketing',
    path: '/appointments',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    name: 'Todos',
    moduleGroupKey: 'tasks_support',
    path: '/todos_monthly_view',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
    ),
  },
  {
    name: 'System Status',
    moduleGroupKey: 'tasks_support',
    path: '/system-health',
    permissionModuleKey: 'system_health',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
  },
  {
    name: 'Signatures',
    moduleGroupKey: 'communication',
    path: '/email-signatures',
    permissionModuleKeys: ['email_signatures', 'emails'],
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
      </svg>
    ),
  },
  {
    name: 'Settings',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
      </svg>
    ),
    children: [
      {
        name: 'System',
        moduleGroupKey: 'admin_settings',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        ),
        children: [
          { name: 'Users', path: '/admin/users', icon: ListIcon },
          { name: 'Settings', path: '/configuration-settings', icon: ListIcon },
          {
            name: 'Parameters',
            path: '/parameters',
            icon: ListIcon,
            permissionModuleKeys: [...PARAMETER_PERMISSION_MODULE_KEYS],
          },
        ],
      },
      {
        name: 'AI',
        icon: <Sparkles className="w-5 h-5" strokeWidth={1.75} aria-hidden />,
        children: [
          {
            name: 'AI Prompts',
            path: '/ai-prompts',
            icon: ListIcon,
            permissionModuleKey: 'configuration_settings',
          },
          {
            name: 'AI Usage',
            path: '/ai-usage',
            icon: ListIcon,
            permissionModuleKey: 'configuration_settings',
          },
        ],
      },
      {
        name: 'Monitoring',
        moduleGroupKey: 'admin_settings',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        ),
        children: [
          { name: 'Sync Logs', path: '/admin/email-logs', icon: ListIcon },
          { name: 'System Health', path: '/admin/system-health', icon: ListIcon, requiresEdit: true },
          { name: 'Activity Logs', path: '/activity-logs', icon: ListIcon },
        ],
      },
      {
        name: 'Email Setup',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        ),
        children: [
          { name: 'Email Accounts', path: '/email-accounts', icon: ListIcon },
          { name: 'Smart Folders', path: '/smart-folders', icon: ListIcon },
          { name: 'Email Rules', path: '/email-rules', icon: ListIcon },
        ],
      },
      {
        name: 'Tools',
        moduleGroupKey: 'tools_data_management',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        ),
        children: [
          { name: 'Database Browser', path: '/tools/database-browser', icon: ListIcon },
          { name: 'Import Organizations', path: '/tools/import-organizations', icon: ListIcon },
        ],
      },
    ],
  },
];

function getViewModuleKey(view: MenuItemView): string | undefined {
  return resolveModuleKeyForPath(view.path) ?? getModuleKeyForPath(view.path);
}

function viewAllowedByPermission(
  view: MenuItemView,
  canView: ((moduleKey: string) => boolean) | undefined,
): boolean {
  if (!canView) return true;
  const moduleKey = getViewModuleKey(view);
  if (!moduleKey) return true;
  return canView(moduleKey);
}

function filterViewsByPermission(
  views: MenuItemView[] | undefined,
  canView: ((moduleKey: string) => boolean) | undefined,
): MenuItemView[] | undefined {
  if (!views || views.length === 0) return views;
  const filtered = views.filter((view) => viewAllowedByPermission(view, canView));
  return filtered.length > 0 ? filtered : undefined;
}

function getItemModuleKey(item: MenuItem): string | undefined {
  if (item.permissionModuleKey) return item.permissionModuleKey;
  const path = item.path ?? item.views?.[0]?.path;
  return path ? (resolveModuleKeyForPath(path) ?? getModuleKeyForPath(path)) : undefined;
}

function itemAllowedByPermission(
  item: MenuItem,
  canView: ((moduleKey: string) => boolean) | undefined,
  canEdit?: ((moduleKey: string) => boolean) | undefined,
): boolean {
  if (!canView) return true;

  if (item.views && item.views.length > 0) {
    const allowedViews = filterViewsByPermission(item.views, canView);
    return (allowedViews?.length ?? 0) > 0;
  }

  if (item.permissionModuleKeys && item.permissionModuleKeys.length > 0) {
    return item.permissionModuleKeys.some((key) => canView(key));
  }

  const moduleKey = getItemModuleKey(item);
  if (!moduleKey) return true;
  if (!canView(moduleKey)) return false;
  if (item.requiresEdit && canEdit && !canEdit(moduleKey)) return false;
  return true;
}

function applyItemPermissions(
  item: MenuItem,
  canView: ((moduleKey: string) => boolean) | undefined,
  canEdit?: ((moduleKey: string) => boolean) | undefined,
): MenuItem {
  const views = filterViewsByPermission(item.views, canView);
  const children = filterChildrenByPermission(item.children, canView, canEdit);

  let path = item.path;
  if (views && views.length > 0) {
    const allowedPaths = new Set(views.map((view) => view.path));
    if (!path || !allowedPaths.has(path)) {
      path = views[0].path;
    }
  }

  return {
    ...item,
    path,
    views,
    children,
  };
}

function filterChildrenByPermission(
  children: MenuItem[] | undefined,
  canView: ((moduleKey: string) => boolean) | undefined,
  canEdit?: ((moduleKey: string) => boolean) | undefined,
): MenuItem[] | undefined {
  if (!children || children.length === 0) return children;
  const filtered = children
    .filter((child) => itemAllowedByPermission(child, canView, canEdit))
    .map((child) => ({
      ...child,
      children: filterChildrenByPermission(child.children, canView, canEdit),
    }))
    .filter((child) => {
      const hasContent = !!child.path || (child.children && child.children.length > 0) || (child.views && child.views.length > 0);
      return hasContent;
    });
  return filtered.length > 0 ? filtered : undefined;
}

export const getSidebarItems = (
  role?: string,
  canView?: (moduleKey: string) => boolean,
  canEdit?: (moduleKey: string) => boolean,
): MenuItem[] => {
  const items = [...sidebarItems];
  let result = items;
  if (canView) {
    result = result
      .filter((item) => itemAllowedByPermission(item, canView, canEdit))
      .map((item) => applyItemPermissions(item, canView, canEdit))
      .filter((item) => !!item.path || (item.children && item.children.length > 0) || (item.views && item.views.length > 0));
  }
  return result;
};

export type SidebarSearchLabels = {
  menu: (name: string) => string;
  view?: (label: string) => string;
};

export function flattenSidebarItemsForSearch(
  items: MenuItem[],
  parentGroup?: string,
  labels?: SidebarSearchLabels,
): { label: string; path: string; group?: string; icon?: React.ReactNode }[] {
  const menu = (name: string) => labels?.menu(name) ?? name;
  const viewText = (label: string) => (labels?.view ? labels.view(label) : label);
  const out: { label: string; path: string; group?: string; icon?: React.ReactNode }[] = [];
  for (const item of items) {
    if (item.name === 'Favorites') continue;
    const path = item.path ?? item.views?.[0]?.path;
    const group = parentGroup ? menu(parentGroup) : (item.children?.length ? menu(item.name) : undefined);

    if (item.views && item.views.length > 0) {
      for (const view of item.views) {
        const viewLabel =
          item.views.length > 1 ? `${menu(item.name)} – ${viewText(view.label)}` : menu(item.name);
        out.push({ label: viewLabel, path: view.path, group, icon: view.icon ?? item.icon });
      }
    } else if (path) {
      out.push({ label: menu(item.name), path, group, icon: item.icon });
    }
    if (item.children?.length) {
      for (const child of item.children) {
        const childPath = child.path ?? child.views?.[0]?.path;
        if (childPath) {
          out.push({ label: menu(child.name), path: childPath, group: menu(item.name), icon: child.icon });
        }
        if (child.children?.length) {
          out.push(...flattenSidebarItemsForSearch(child.children, item.name, labels));
        }
      }
    }
  }
  return out;
}
